module.exports = {};


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/modules/$.iterators.js
 ** module id = 25
 ** module chunks = 0
 **/